
/*
 * BUILD @athena/forge v9.0.0
 * THIS IS AN AUTOGENERATED FILE
 */

import React from 'react';
import IconBase from '../_IconBase';
const DiagnosisProblems = props => {
  const modClassName = props.className;

  return (
    <IconBase viewBox="0 0 25 25" {...props} className={ modClassName }>
      <g>
        <g className="fe_c_icon__background">
          <rect width="25" height="25"></rect>
        </g>
        <g className="fe_c_icon__icon fe_c_icon__icon--primary">
          <g>
            <path d="M16.7,3.4V2.8A1.8,1.8,0,0,0,14.9,1H10.1A1.8,1.8,0,0,0,8.3,2.8v.6H2.8V19.5H18.9a3.3,3.3,0,0,0,3.3-3.3V3.4ZM9.8,2.8a.3.3,0,0,1,.3-.3h4.8a.3.3,0,0,1,.3.3v.6H9.8ZM20.7,16.2A1.8,1.8,0,0,1,18.9,18H4.3V4.9H20.7Z"></path>
            <polygon points="11.8 15.4 13.3 15.4 13.3 12.2 16.4 12.2 16.4 10.7 13.3 10.7 13.3 7.6 11.8 7.6 11.8 10.7 8.6 10.7 8.6 12.2 11.8 12.2 11.8 15.4"></polygon>
          </g>
        </g>
      </g>
    </IconBase>);
};

DiagnosisProblems.defaultProps = {
  title: 'Diagnosis Problems',
};

export default DiagnosisProblems;
